import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePOSStore } from '../stores/posStore';

export default function Checkout(): JSX.Element {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const cart = usePOSStore((state) => state.cart);
  const getCartTotal = usePOSStore((state) => state.getCartTotal);
  const createOrder = usePOSStore((state) => state.createOrder);
  const isOnline = usePOSStore((state) => state.isOnline);

  if (cart.length === 0) {
    return (
      <div className="p-4 text-center">
        <div className="text-gray-500 text-lg mb-4">Your cart is empty</div>
        <button
          onClick={() => navigate('/')}
          className="bg-blue-600 text-white px-4 py-2 rounded font-medium hover:bg-blue-700 transition-colors"
        >
          Continue Shopping
        </button>
      </div>
    );
  }

  const handleCheckout = async (): Promise<void> => {
    setProcessing(true);
    try {
      const order = await createOrder();
      if (order) {
        alert(
          `Order ${order.id} created successfully${!isOnline ? ' (will sync when online)' : ''}`
        );
        navigate('/');
      }
    } catch (error) {
      alert('Failed to create order');
      console.error(error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Checkout</h2>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
        <p className="text-sm text-blue-800">
          {isOnline
            ? '✓ Online - Order will be submitted immediately'
            : '⚠ Offline - Order will be saved locally and synced when online'}
        </p>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
        <h3 className="font-semibold mb-3">Order Summary</h3>
        <div className="space-y-2 mb-4">
          {cart.map((item) => (
            <div key={item.productId} className="flex justify-between text-sm">
              <span>
                {item.product.name} x {item.quantity}
              </span>
              <span>₦{(item.price * item.quantity).toFixed(2)}</span>
            </div>
          ))}
        </div>
        <div className="border-t border-gray-200 pt-3">
          <div className="flex justify-between items-center">
            <span className="font-semibold">Total:</span>
            <span className="text-2xl font-bold text-blue-600">₦{getCartTotal().toFixed(2)}</span>
          </div>
        </div>
      </div>

      <button
        onClick={handleCheckout}
        disabled={processing}
        className="w-full bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        {processing ? 'Processing...' : 'Complete Order'}
      </button>

      <button
        onClick={() => navigate('/cart')}
        className="w-full mt-2 bg-gray-200 text-gray-900 py-2 rounded-lg font-medium hover:bg-gray-300 transition-colors"
      >
        Back to Cart
      </button>
    </div>
  );
}
